import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import {
  Affix,
  Anchor,
  BackTop,
  Button,
  Calendar,
  Card,
  Carousel,
  Col,
  Collapse,
  DatePicker,
  Drawer,
  Empty,
  Icon,
  Input,
  InputNumber,
  List,
  Menu,
  message,
  Popover,
  Radio,
  Row,
  Select,
  Slider,
  Switch,
  Tabs,
  Upload
} from 'ant-design-vue';
import * as XLSX from 'xlsx';
import printJS, {Configuration} from 'print-js';
import * as moment from 'moment';
import {Moment} from 'moment';
import VueAxios from 'vue-axios';
import CikeApi, {CikeAxios} from './request';
import {CikeUtils} from './utils';
import 'moment/locale/zh-cn';
import {CKBJson} from '@antv/knowledge';
import {ChartKnowledgeJSON} from '@antv/knowledge/lib/interface';

declare module 'vue/types/vue' {

  interface Vue {
    $staticPath: string;
    $xls: any;
    $axios: CikeApi | any;
    $moment: Moment;
    $utils: CikeUtils;
    $print: (options: Configuration) => {};
    $CKBJson: Record<string, ChartKnowledgeJSON>;
  }
}

//antUI载入
Vue.use(Button);
Vue.use(Anchor);
Vue.use(Col);
Vue.use(Row);
Vue.use(Collapse);
Vue.use(Calendar);
Vue.use(Carousel);
Vue.use(BackTop);
Vue.use(Radio);
Vue.use(DatePicker);
Vue.use(Icon);
Vue.use(Tabs);
Vue.use(Affix);
Vue.use(Switch);
Vue.use(List);
Vue.use(Card);
Vue.use(Select);
Vue.use(Upload);
Vue.use(Drawer);
Vue.use(Input);
Vue.use(Slider);
Vue.use(Popover);
Vue.use(InputNumber);
Vue.use(Empty);
Vue.use(Menu);
Vue.config.productionTip = true;
Vue.config.silent = true;


message.config({
  top: '25%',
  duration: 2,
  maxCount: 3,
});
/*vue-axios载入*/
Vue.use(VueAxios, CikeAxios());
//此刻接口api挂载
Vue.prototype.$axios = new CikeApi();
Vue.prototype.$message = message;
Vue.prototype.$xls = XLSX;
Vue.prototype.$print = printJS;
Vue.prototype.$utils = new CikeUtils();
Vue.prototype.$CKBJson = CKBJson('zh-CN', true);

//moment工具包
moment.locale('zh-hk');
// @ts-ignore
Vue.prototype.$moment = moment();


//开发插件载入
// Before you create app
/**浏览器类型获取*/
function myBrowser() {
  let userAgent = navigator.userAgent; //取得浏览器的userAgent字符串
  let isOpera = userAgent.indexOf('Opera') > -1; //判断是否Opera浏览器
  let isIE = userAgent.indexOf('compatible') > -1
    && userAgent.indexOf('MSIE') > -1 && !isOpera; //判断是否IE浏览器
  let isEdge = userAgent.indexOf('Edge') > -1; //判断是否IE的Edge浏览器
  let isFF = userAgent.indexOf('Firefox') > -1; //判断是否Firefox浏览器
  let isSafari = userAgent.indexOf('Safari') > -1
    && userAgent.indexOf('Chrome') == -1; //判断是否Safari浏览器
  let isChrome = userAgent.indexOf('Chrome') > -1
    && userAgent.indexOf('Safari') > -1; //判断Chrome浏览器

  if (isIE) {
    let reIE = new RegExp('MSIE (\\d+\\.\\d+);');
    reIE.test(userAgent);
    let fIEVersion = parseFloat(RegExp['$1']);
    if (fIEVersion == 7) {
      return 'IE7';
    } else if (fIEVersion == 8) {
      return 'IE8';
    } else if (fIEVersion == 9) {
      return 'IE9';
    } else if (fIEVersion == 10) {
      return 'IE10';
    } else if (fIEVersion == 11) {
      return 'IE11';
    } else {
      return '0';
    }//IE版本过低
    return 'IE';
  }
  if (isOpera) {
    return 'Opera';
  }
  if (isEdge) {
    return 'Edge';
  }
  if (isFF) {
    return 'FF';
  }
  if (isSafari) {
    return 'Safari';
  }
  if (isChrome) {
    return 'Chrome';
  }

}

/*
if (process.env.NODE_ENV === 'development') {
  Vue.config.devtools = process.env.NODE_ENV === 'development';
// @ts-ignore
  window.__VUE_DEVTOOLS_GLOBAL_HOOK__.Vue = app.constructor;
}
*/

// After you create app
new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
